module.exports = __webpack_public_path__ + "img/PCM_Ergebnis.d69ba28a.jpg";